<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="版本控制">
        <span slot="label"><i class="iconfont icon-system-setting" style="font-size: 14px"></i>&nbsp;版本控制</span>
        <el-card class="box-card" style="height: 100%" shadow="always">
          <div class="ml-1 mt-2">
            版本号:
            <el-input style="width: 150px" class="mr-2" type="string" v-model="h5_version">
            </el-input>
          </div>
          <el-button type="success" @click="saveH5VersionData" class="mt-2">{{ $t("common.save") }}</el-button>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="利润设置">
        <span slot="label"><i class="fa fa-cny" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_profit_setting")
          }}</span>
        <ProfitSetting></ProfitSetting>
      </el-tab-pane>
      <el-tab-pane label="数据同步" v-if="is_production">
        <span slot="label"><i class="fa fa-handshake-o" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_data_sync")
          }}</span>
        <div>
          <el-progress v-if="is_show_percentage" :stroke-width="18" :text-inside="true" style="width:40%"
            :percentage="percentage" :color="customColors">
          </el-progress>
          <div v-if="is_show_percentage">{{ $t("common.table_name") }}：{{ current_async_table_name }}</div>
          <el-button type="primary" @click="asyncData" class="mt-2">{{ $t("common.start_sync") }}</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="邮件通知人">
        <span slot="label"><i class="iconfont icon-email" style="font-size: 14px"></i>&nbsp;{{
          $t("tab.tab_email_notifier") }}</span>
        <el-row class="mt-2">
          <el-col :span="4" style="text-align:right">{{ $t("common.email_dispatch_return") }}：</el-col>
          <el-col :span="20">
            <el-select filterable clearable multiple reserve-keyword :placeholder="$t('common.action_select')"
              class="ml-2" v-model="dispatch_return_email_users" style="width: 20rem">
              <el-option v-for="(item, index) in $store.state.biz_data.baseData.Users" :key="index"
                :label="item.username" :value="item.username">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="mt-2">
          <el-col :span="4" style="text-align:right">{{ $t("common.email_dispatch_exception") }}：</el-col>
          <el-col :span="20">
            <el-select filterable clearable multiple reserve-keyword :placeholder="$t('common.action_select')"
              class="ml-2" v-model="dispatech_error_email_users" style="width: 20rem">
              <el-option v-for="(item, index) in users" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="mt-2">
          <el-col :span="4" style="text-align:right">{{ $t("common.email_dispatch_exception_handle") }}：</el-col>
          <el-col :span="20">
            <el-select filterable clearable multiple reserve-keyword :placeholder="$t('common.action_select')"
              class="ml-2" v-model="dispatech_error_handling_users" style="width: 20rem">
              <el-option v-for="(item, index) in users" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="mt-2">
          <el-col :span="4" style="text-align:right">{{ $t("common.email_purch") }}：</el-col>
          <el-col :span="20">
            <el-select filterable clearable multiple reserve-keyword :placeholder="$t('common.action_select')"
              class="ml-2" v-model="purch_email_users" style="width: 20rem">
              <el-option v-for="(item, index) in users" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="mt-2">
          <el-col :span="4" style="text-align:right">{{ $t("common.email_quote_proofing_purch_distribut") }}：</el-col>
          <el-col :span="20">
            <el-select filterable clearable multiple reserve-keyword :placeholder="$t('common.action_select')"
              class="ml-2" v-model="quote_proofing_purch_distribut_email_users" style="width: 20rem">
              <el-option v-for="(item, index) in users" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="mt-2">
          <el-col :span="4" style="text-align:right">{{ $t("common.email_quote_proofing") }}：</el-col>
          <el-col :span="20">
            <el-select filterable clearable multiple reserve-keyword :placeholder="$t('common.action_select')"
              class="ml-2" v-model="quote_proofing_email_users" style="width: 20rem">
              <el-option v-for="(item, index) in users" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <!-- <el-row class="mt-2">
          <el-col :span="4" style="text-align:right">{{$t("common.email_first_mt")}}：</el-col>
          <el-col :span="20">
            <el-select filterable clearable reserve-keyword :placeholder="$t('common.action_select')" class="ml-2" v-model="mt_email_user"
              style="width: 20rem">
              <el-option v-for="(item,index) in users" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row> -->
        <el-row class="mt-2">
          <el-col :span="4" style="text-align:right">
            <el-button type="success" class="mt-2" @click="saveEmailData">{{ $t("common.save") }}</el-button>
          </el-col>
          <el-col :span="20"></el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="多语言设置">
        <span slot="label"><i class="iconfont icon-language login-lang-icon"></i>&nbsp;{{ $t("tab.tab_language_setting")
          }}</span>
        <sys-lang-setting></sys-lang-setting>
      </el-tab-pane>
      <el-tab-pane label="首页设置">
        <span slot="label"><i class="iconfont icon-system-setting" style="font-size: 14px"></i>&nbsp;首页设置</span>
        <SysDashboardSetting></SysDashboardSetting>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import ExternalUserSettingCust from "./ExternalUserSettingCust";
// -- import * as _ from "lodash-es"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as SystemSettingController from "../../controllers/system/SystemSettingController"
import ProfitSetting from "./ProfitSetting"
import SysDashboardSetting from "./SysDashboardSetting.vue"
import SysLangSetting from './SysLangSetting.vue'

export default {
  name: "SystemSetting",
  components: {
    ProfitSetting,
    SysLangSetting,
    SysDashboardSetting
  },
  data() {
    return {
      is_production: false,
      tab_index: 0,
      profit_id: "",
      dispatch_return_email_users: [],
      dispatech_error_email_users: [],
      dispatech_error_handling_users: [],
      purch_email_users: [],//采购邮件通知人
      quote_proofing_purch_distribut_email_users: [],//打样报价采购预分配完成后邮件通知人
      quote_proofing_email_users: [],//打样分配完成后邮件通知人(销售总监)
      mt_email_user: "",//MT第一审批人
      percentage: 0,
      is_show_percentage: false,
      current_async_table_name: "",
      customColors: [
        { color: '#f56c6c', percentage: 30 },
        { color: '#e6a23c', percentage: 70 },
        { color: '#5cb87a', percentage: 100 },
        // { color: '#1989fa', percentage: 80 },
        // { color: '#6f7ad3', percentage: 100 }
      ],
      h5_version: ""
    }
  },
  created() {
    if (window.location.host.indexOf("test.cpspcloud") > -1 || window.location.host.indexOf(":8081") > -1) {
      this.is_production = true
    }
  },
  async mounted() {
    // this.is_production = !this.$store.state.is_production

    await this.GetData()
    await this.GetH5Version()
  },
  computed: {
    users() {
      let _UserOptions = []
      let _result = this.$store.state.biz_data.baseData.Users
      if (_result && _result.length > 0) {
        _.each(_result, (t) => {
          _UserOptions.push({
            value: t.username,
            label: t.username,
          })
        })
      }
      this.getRole(_UserOptions)
      return _UserOptions
    },
  },
  methods: {
    async getRole(dt) {
      let _result = await RoleManageController.methods.GetRoleList()
      _result = _.filter(_result, { is_sys: false })
      if (_result && _result.length > 0) {
        _.each(_result, (t) => {
          dt.push({
            value: t.code,
            label: t.code + " : " + t.name,
          })
        })
      }
    },
    async GetData() {
      let result = await SystemSettingController.methods.GetData({ code: { "=": "email_notifier" } })

      if (result[0].length < 1) {
        return
      } else {
        this.profit_id = result[0][0].id
        let m = result[0][0].setting_value ? JSON.parse(result[0][0].setting_value) : {}
        this.dispatch_return_email_users = m.emailNotifier
        this.dispatech_error_email_users = m.dispatchErrorEmailNotifier
        this.dispatech_error_handling_users = m.dispatchErrorHandler
        this.purch_email_users = m.purchEmailNotifier
        this.quote_proofing_purch_distribut_email_users = m.PurchDistributionQuoteProofingEmailNotifier
        this.quote_proofing_email_users = m.quoteProofingEmailNotifier
        this.mt_email_user = m.mtEmailNotifier
      }
    },
    async asyncData() {
      this.percentage = 0
      this.current_async_table_name = ""
      let is_ok = await this.msgModal("确定要开始同步吗？")
      if (is_ok) {
        let result = await SystemSettingController.methods.GetAsyncTable()
        if (result && result.length > 0) {
          this.is_show_percentage = true
          let sep = 0
          for (var i in result) {
            sep += 1
            this.percentage = _.round((sep / result.length * 100), 0)
            this.current_async_table_name = result[i].table_name
            await SystemSettingController.methods.SyncData(result[i])
          }
          if (this.percentage == 100) {
            this.msgToasts("同步成功!", "success")
          }
        }
      }
    },
    async saveEmailData() {
      if (this.dispatch_return_email_users.length == 0) {
        this.msgToasts("请选择派发退回邮件通知人!", "info")
        return
      }
      let _params = {}
      _params.setting_value = JSON.stringify({
        emailNotifier: this.dispatch_return_email_users,
        dispatchErrorEmailNotifier: this.dispatech_error_email_users,
        dispatchErrorHandler: this.dispatech_error_handling_users,
        purchEmailNotifier: this.purch_email_users,
        PurchDistributionQuoteProofingEmailNotifier: this.quote_proofing_purch_distribut_email_users,
        quoteProofingEmailNotifier: this.quote_proofing_email_users,
        mtEmailNotifier: this.mt_email_user
      })
      _params.code = "email_notifier"
      _params.id = this.profit_id
      let result = await SystemSettingController.methods.SaveData(_params)
      //
      if (result) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.profit_id = result[0][0].id
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
      }
    },
    ///版本控制
    async GetH5Version() {
      let result = await SystemSettingController.methods.GetData({ code: { "=": "h5_version" } })

      if (result[0].length < 1) {
        return
      } else {
        this.profit_id = result[0][0].id
        this.h5_version = result[0][0].setting_value ? result[0][0].setting_value : ''
      }
    },
    async saveH5VersionData() {
      if (this.h5_version === "") {
        this.msgToasts("请输入版本号!", "info")
        return
      }
      let _params = {}
      _params.setting_value = this.h5_version
      _params.code = "h5_version"
      _params.id = this.profit_id
      let result = await SystemSettingController.methods.SaveData(_params)
      if (result) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.profit_id = result[0][0].id
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
      }
    },
  }
}
</script>
